/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Nav_Group_FinanceInputs */



/**
* | output |
* | --- |
* | "Finance" |
*
* @param {Partner_Nav_Group_FinanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_nav_group_finance = /** @type {((inputs?: Partner_Nav_Group_FinanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Nav_Group_FinanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Finanzen")
	return /** @type {LocalizedString} */ ("Finance")
});